import { FCX } from "@datassential/platform-ui-lib";
import HomeSectionSubTitle from "@pages/Home/components/HomeSectionSubTitle";
import { useHomeCategoryRecommendedCharts } from "@apiHooks/useHomeCategoryRecommendedCharts";
import RecommendedCharts from "@vms/RecommendedCharts";
import { useMemo, useState } from "react";
import AccessLink from "@components/AccessLink/AccessLink";
import HomeSectionFooter from "@pages/Home/components/HomeSectionFooter";
import { RecommendedChartTypeEnum } from "@models/RecommendedCharts";
import { PermissionLevelEnum } from "@models/PermissionSection";

const HomeCategoryRelatedCharts: FCX<{
    categoryName: string;
}> = ({
    categoryName,
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const categoryNameToFetch = useMemo(
        () => {
            switch (categoryName.trim().toLowerCase()) {
                case "condiment": return "Sauce";
                default: return categoryName;
            }
        },
        [categoryName]
    );

    const {
        isLoading,
        data: { data: rawData, permissionLevel },
    } = useHomeCategoryRecommendedCharts(categoryNameToFetch);

    const data = useMemo(
        () => rawData.filter(i => i.typeLabel !== RecommendedChartTypeEnum.Mac),
        [rawData]
    );

    const hasData = data.length > 0;
    const hasAccess = useMemo(
        () => permissionLevel === PermissionLevelEnum.Full,
        [permissionLevel]
    );

    const showFooter = !isLoading && data.length > 16;

    if (!isLoading && (!hasData || !hasAccess)) return null;

    return (
        <div className="HomeCategoryRelatedCharts">
            <HomeSectionSubTitle>Related Charts & Data: {categoryName}</HomeSectionSubTitle>
            <RecommendedCharts
                data={data}
                isExpanded={isExpanded}
                isLoading={isLoading}
            />
                <HomeSectionFooter style={{ paddingTop: 0 }}>
                    <AccessLink
                        url={null}
                        hideArrowIcon
                        text={showFooter ? `Show ${isExpanded ? 'Less' : 'More'}` : ''}
                        hasAccess={true}
                        onClick={() => setIsExpanded((prev) => !prev)}
                        onContactUsClick={() => {}}
                    />
                </HomeSectionFooter>
        </div>
    );
};

export default HomeCategoryRelatedCharts;